<template>
  <div class="ff-primary fs-14 whatsapp-dialog">
    <div class="text-center s-mb-3 s-mt-5">
      <img src="https://cdn.karier.mu/assets/illustration/dialog/whatsapp/notifikasi-ponsel.webp" width="192" height="144" alt="Notifikasi Ponsel" class="d-inline-block align-middle">
    </div>
    <div class="s-mb-5 text-ui-primary">Sekarang Anda bisa mendapatkan notifikasi terbaru terkait <span class="fw-600">proses belajar</span> melalui WhatsApp!</div>
    <s-tag
      v-if="userInfo.phone"
      variant="info"
      type="highlight"
      class="s-mb-5"
      cluster="k"
    >
      Nomor ponsel yang dimasukkan sebelumnya: <span class="fw-600">{{ userInfo.phone }}</span>
    </s-tag>
    <s-input
      @input="handleInput"
      id="input-whatsapp"
      class="mw-100"
      v-model="value"
      label="Masukkan nomor WhatsApp"
      autocomplete="off"
      cluster="k"
      :error="errorMessage"
      :disabled="false"
      :padding-right="44"
      :max="15"
    />
  </div>
</template>

<script>

export default {
  name: 'ContentWhatsappDialog',
  data () {
    return {
      value: null,
      errorMessage: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    handleInput (newValue) {
      this.value = newValue
      this.$emit('input', this.value)
      this.validatePhoneNumber()
    },
    validatePhoneNumber () {
      const regex = /^\+?\d{9,15}$/
      if (!regex.test(this.value)) {
        this.errorMessage = 'Format tidak sesuai. Periksa dan coba lagi.'
        this.$emit('validate', false)
      } else {
        this.$emit('validate', true)
        this.errorMessage = ''
      }
    }
  },
  watch: {
    value (newValue) {
      if (newValue.length === 0) {
        this.errorMessage = ''
      }
    }
  }
}
</script>

<style scoped>
.whatsapp-dialog {
  max-width: 448px;
}

.k-tag.s-tag-highlight.is-info {
  background-color: var(--color-neutral-400);
}
</style>
